import Link from 'next/link';

const Footer = () => {
  return (
    <footer className="py-6 md:py-8 w-full max-w-6xl mx-auto flex justify-center items-center">
      <div className="flex items-center gap-4 text-xs text-muted-foreground/80">
        <Link
          href="/pricing"
          className="hover:text-foreground transition-colors"
        >
          Pricing
        </Link>
        <Link
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors"
        >
          Privacy Policy
        </Link>
        <Link
          href="/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors"
        >
          Terms and Conditions
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
